import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const Background = styled.div`
  max-height: ${({ heroHeight }) => (heroHeight && heroHeight.xs ? heroHeight.xs : '200px')};

  @media (min-width: ${fullConfig.theme.screens.sm}) {
    max-height: ${({ heroHeight }) => (heroHeight && heroHeight.sm ? heroHeight.sm : '500px')};
  }

  @media (min-width: ${fullConfig.theme.screens.xl}) {
    max-height: ${({ heroHeight }) => (heroHeight && heroHeight.xl ? heroHeight.xl : '800px')};
  }
`;

const BackgroundInner = styled.div`
  background-image: url(${({ xs }) => xs.url});

  @media (min-width: ${fullConfig.theme.screens.sm}) {
    background-image: url(${({ sm }) => sm.url});
  }

  @media (min-width: ${fullConfig.theme.screens.md}) {
    background-image: url(${({ md }) => md.url});
  }

  @media (min-width: ${fullConfig.theme.screens.xl}) {
    background-image: url(${({ xl }) => xl.url});
  }
`;

export { Background, BackgroundInner };
